import './TitleInput.scss';

const TitleInput = ({ placeholder, onChange, value }) => {
  return <input className="TitleInput" placeholder={placeholder} onChange={onChange} value={value} />;
};

export default TitleInput;
